import StatisticCard from "./StatisticCard";

export default function Statistics({cdf, usd}){
    return(
            <div className="row">
                <div className="col-lg-6">
                    <StatisticCard title={"USD Account"} balance={"$" + usd.balance} incoming={"+" + usd.incomingBalance}
                                   outgoing={"-" + usd.outgoingBalance}/>
                </div>
                <div className="col-lg-6">
                    <StatisticCard title={"CDF Account"} balance={"CDF" + cdf.balance} incoming={"+" + cdf.incomingBalance}
                                   outgoing={"-" + cdf.outgoingBalance}/>
                </div>
            </div>
    );
}